/**
 * Модель транспорта на карте
 * @property {int} id Идентификатор
 * @property {string} registrationNumber Регистрационный номер
 * @property {string} type Вид транспорта (из справочника видов ТС)
 * @property {double[]} coordinate Координата расположения транспорта
 */
var VehicleMapModel = (function () {

  /**
   * @constructor
   * @param {} vehicle
   */
  function VehicleMapModel(vehicle) {
    if (vehicle) {
      this.id = vehicle.Id;
      this.type = vehicle.Type;
      this.typeId = vehicle.TypeId;
      this.registrationNumber = vehicle.RegistrationNumber;
      this.coordinate = [vehicle.Latitude, vehicle.Longitude];
      this.speed = vehicle.Speed;
    }
  }

  return VehicleMapModel;
}());
